import { Spin } from 'antd'

import { ButtonSizeType, IButton } from './types'
import css from "./index.module.scss"


/** Компонент Button */
export const Button = ({
    id,
    name,
    type = 'button',
    children,
    size = 'md',
    variant = 'primary',

    width,
    maxWidth,
    padding,

    position = 'relative',
    left,
    top, 
    right, 
    bottom,

    flexGrow, 
    flexBasis,

    isDisabled = false,
    isLoading = false,
    isRendered = true,
    isVisible = true,

    onClick,
}: IButton) => {
    /** Стили компоненты */
    const componentStyle: React.CSSProperties = {
        display: isVisible ? 'flex' : 'none',
        position: position,
        left: left,
        top: top,
        right: right,
        bottom: bottom,

        flexGrow: flexGrow,
        flexBasis: flexBasis
    }

    /** Стили button */
    const buttonStyle: React.CSSProperties = {
        width: width, 
        maxWidth: maxWidth, 
        padding: padding,
    }

    const getSizeClassName = (size?: ButtonSizeType) => {
        switch (size) {
            case 'lg': return css.lg
            case 'md': return css.md
            case 'sm': return css.sm
            case 'xs': return css.xs
            case 'clear': return css.clear
            default: return css.md
        }
    }

    return <>
        {isRendered && <div className={css.buttonWrapper} style={componentStyle}>
            <button
                id={id}
                name={name}
                type={type}
                disabled={isDisabled}
                className={`${css[variant]} ${getSizeClassName(size)}`}
                style={buttonStyle}
                onClick={onClick}
            >
                {children}
            </button>

            {isLoading && <div className={css.isLoading}><Spin size='small' styles={{ indicator: { color: 'var(--color_txt_accent)' } }} /></div>}
        </div>}
    </>
}